module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page profile-grid-page members-page mx-5 text-black",
    staticStyle: {
      "color": "black !important"
    }
  }, [_c('content-top-header', {
    attrs: {
      "height": "auto"
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "user-top-wrapper"
  }, [_c('li', {
    staticClass: "user-profile-section"
  }, [_c('div', {
    staticClass: "user-profile-image-section"
  }, [_c('div', {
    staticClass: "user-profile-image",
    style: ({
      'background-image': ("url(" + (_vm.user.avatar.url) + ")"),
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-info-section"
  }, [_c('div', {
    staticClass: "user-name-section"
  }, [_c('span', {
    staticClass: "user-role"
  }, [_vm._v(_vm._s(_vm.user.user_type))]), _vm._v(" "), _c('div', {
    staticClass: "display-name"
  }, [_vm._v("\n                  " + _vm._s(_vm.user.username) + "\n                  "), _c('v-icon', {
    staticClass: "user-status online"
  }, [_vm._v("fa-check-circle")])], 1), _vm._v(" "), _c('div', {
    staticClass: "display-name-bottom"
  }, [_vm._v("\n                  MEMBERS SECTIONS "), (_vm.last_updated) ? _c('span', {
    staticClass: "user-role"
  }, [_vm._v("Last Updated: " + _vm._s(_vm.last_updated))]) : _vm._e()])])])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "d-flex align-items-center option-toolbar"
  }, [_c('v-select', {
    staticClass: "large",
    attrs: {
      "items": _vm.tierList,
      "item-text": "name",
      "placeholder": "Select option",
      "item-value": "value",
      "single-line": "",
      "bottom": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.tier),
      callback: function($$v) {
        _vm.tier = $$v
      },
      expression: "tier"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close-btn"
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "variant": "text",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: ("/" + (_vm.user.slug))
        })
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)])], 1)])], 2), _vm._v(" "), _c('div', {
    staticClass: "members-track profile-track mt-5"
  }, [(_vm.albums.length) ? _c('div', {
    staticClass: "_body list-track-container list-track-view list-track-view-trackCard"
  }, [_vm._m(0), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": "",
      "pl-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "id": "trending-product-container"
    }
  }, _vm._l((_vm.albums), function(feed, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "product-list",
      attrs: {
        "xs6": "",
        "sm4": "",
        "lg3": ""
      }
    }, [_c('track-card', {
      attrs: {
        "objects": _vm.albums,
        "objectIndex": index,
        "willMenuRender": ""
      }
    })], 1)
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.videos.length) ? _c('div', {
    staticClass: "dflex justify-space-between align-center mt-5 mb-3"
  }, [_c('div', {
    staticClass: "text-big"
  }, [_vm._v("EXCLUSIVE VIDEOS")])]) : _vm._e(), _vm._v(" "), (_vm.videos.length) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": "",
      "pl-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "id": "trending-product-container"
    }
  }, _vm._l((_vm.videos), function(video) {
    return _c('v-flex', {
      key: video.id,
      staticClass: "video-list",
      attrs: {
        "xs6": "",
        "sm4": "",
        "lg3": ""
      }
    }, [_c('video-box', {
      attrs: {
        "hoverOverlay": false,
        "item": video
      }
    })], 1)
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.products.length) ? _c('div', {
    staticClass: "dflex justify-space-between align-center mt-5 mb-3"
  }, [_c('div', {
    staticClass: "text-big"
  }, [_vm._v("EXCLUSIVE PRODUCTS")])]) : _vm._e(), _vm._v(" "), (_vm.products.length) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('v-container', {
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": "",
      "pl-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "id": "trending-product-container"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "product-list",
      attrs: {
        "xs6": "",
        "sm4": "",
        "lg3": ""
      }
    }, [_c('product-card', {
      attrs: {
        "hideOverlay": "",
        "noMeta": _vm.onMobile,
        "altMeta": _vm.onMobile,
        "altMetaPrice": _vm.onMobile,
        "dataObject": product
      },
      nativeOn: {
        "click": function($event) {
          _vm.productDisplay(product)
        }
      }
    })], 1)
  }))], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex justify-space-between align-center mt-3 mb-3"
  }, [_c('div', {
    staticClass: "text-big"
  }, [_vm._v("EXCLUSIVE MUSIC")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ede03a00","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/members.vue
// module id = 1865
// module chunks = 180